import React from 'react';
import { keyHighlights, images } from '../data/mock';
import { Button } from './ui/button';
import { Check, ArrowRight } from 'lucide-react';

const AirFreight = () => {
  return (
    <section id="air-freight" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <span className="inline-block text-amber-600 font-semibold text-sm uppercase tracking-wider mb-4">
              Air Freight Solutions
            </span>
            <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-6 leading-tight">
              Agile Solutions Offering{' '}
              <span className="text-amber-500">Speed & Reliability</span>{' '}
              Through the Air
            </h2>
            <p className="text-lg text-slate-600 mb-6 leading-relaxed">
              In our world, there are times when 24 hours is just not fast enough. We meet
              the growing demands of our customers when their last-minute requirements
              are fulfilled to the point – when yesterday is too late and life-saving supplies
              need to be delivered to remote locations.
            </p>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              As one of the fastest-growing supply chain organizations globally, Axiom Global
              Freight has developed significant relationships with airline partners with real-time
              flexible schedules, ensuring reliable air cargo transportation and tracking
              facilities for our clients.
            </p>

            <Button
              size="lg"
              className="bg-amber-500 hover:bg-amber-600 text-slate-900 font-semibold px-8 shadow-lg shadow-amber-500/25 hover:shadow-amber-500/40 transition-all duration-300 group"
            >
              Request a Quote
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={images.plane}
                alt="Cargo plane in flight"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 to-transparent" />
            </div>
            {/* Floating Stats Card */}
            <div className="absolute -bottom-8 -left-8 bg-slate-900 rounded-xl p-6 shadow-xl">
              <div className="text-4xl font-bold text-amber-400 mb-1">99.7%</div>
              <div className="text-slate-400 text-sm">On-Time Delivery Rate</div>
            </div>
          </div>
        </div>

        {/* Key Highlights */}
        <div className="mt-24">
          <h3 className="text-2xl font-bold text-slate-900 mb-8 text-center">
            Key Highlights
          </h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {keyHighlights.map((highlight, index) => (
              <div
                key={index}
                className="flex items-center gap-3 bg-slate-50 rounded-xl p-4 hover:bg-amber-50 hover:shadow-md transition-all duration-300 group"
              >
                <div className="w-8 h-8 bg-amber-500/10 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-amber-500/20 transition-colors">
                  <Check className="w-4 h-4 text-amber-600" />
                </div>
                <span className="text-sm font-medium text-slate-700">{highlight}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AirFreight;
